import { Link } from "react-router-dom";

interface AboutSectionProps {
  location?: string;
  locationContext?: string;
}

const AboutSection = ({ location = "Villeurbanne", locationContext = "à Villeurbanne et dans tout le Grand Lyon" }: AboutSectionProps) => {
  return (
    <section className="py-16 px-4 bg-muted/30">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-foreground">
          Votre serrurier professionnel {locationContext}
        </h2>
        
        <div className="space-y-6 text-lg text-muted-foreground leading-relaxed [&a]:underline [&a]:underline-offset-4 [&a]:decoration-2 [&a]:text-secondary [&a:hover]:text-primary [&a]:focus-visible:outline-none [&a]:focus-visible:ring-2 [&a]:focus-visible:ring-ring">
          <p>
            <strong className="text-foreground">Tolstoï Serrurier</strong> est votre expert en{" "}
            <strong>serrurerie {locationContext}</strong>. Spécialisés dans le{" "}
            <Link to="/depannage-urgence" className="text-primary hover:underline">
              dépannage d'urgence
            </Link>
            , nous intervenons rapidement pour toute{" "}
            <Link to="/ouverture-porte" className="text-primary hover:underline">
              ouverture de porte
            </Link>
            , <Link to="/changement-serrure" className="text-primary hover:underline">
              changement de serrure
            </Link>
            , ou{" "}
            <Link to="/reparation-serrure" className="text-primary hover:underline">
              réparation de serrure
            </Link>
            . Nos techniciens certifiés interviennent rapidement {locationContext} ainsi que dans tout le Grand Lyon et la métropole.
          </p>

          <p>
            Notre engagement : vous garantir une <strong>intervention rapide 24h/24 et 7j/7</strong>, 
            un <strong>devis transparent et gratuit</strong> avant toute intervention, et un service 
            de qualité avec des techniques d'ouverture sans casse lorsque c'est possible. Que vous soyez 
            confronté à une porte claquée, une serrure bloquée, ou un besoin de sécurisation après effraction, 
            notre équipe est à votre disposition pour un <strong>dépannage serrure urgence</strong> dans toute 
            la zone du Rhône (69) et de l'Ain (01).
          </p>

          <p>
            Pourquoi choisir <strong>Tolstoï Serrurier</strong> ? Nous sommes des professionnels locaux, 
            disponibles jour et nuit, week-ends et jours fériés. Nos tarifs sont clairs et affichés dès 
            l'appel au <strong><a href="tel:0695220018" className="text-primary hover:underline">06 95 22 00 18</a></strong>. 
            Nous travaillons avec toutes les grandes marques de serrures et sommes également spécialisés 
            dans l'installation de{" "}
            <Link to="/porte-blindee-garage" className="text-primary hover:underline">
              portes blindées
            </Link>{" "}
            et la réparation de{" "}
            <Link to="/volet-roulant" className="text-primary hover:underline">
              volets roulants
            </Link>
            . Faites confiance à un <strong>serrurier {location}</strong> fiable et réactif pour 
            tous vos besoins en serrurerie et sécurisation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
